import RestApiService from './rest.api.service';
;
class ColumnAPIService extends RestApiService {
    constructor() {
        super();
        super.authorized = true;
        super.updateContextPath('columns');
    }
    fetchAll(boardId) {
        let url = '';
        const searchParams = new URLSearchParams();
        if (boardId) {
            searchParams.set('boardId', boardId);
        }
        url += '?' + searchParams.toString();
        return this.get(url);
    }
    create(payload) {
        return this.post('', payload);
    }
    edit(columnId, payload) {
        return this.patch(columnId, payload);
    }
    remove(columnId) {
        return this.delete(columnId);
    }
}
export const columnAPIService = new ColumnAPIService();
